import { FormValidationEvent } from '/@/modules/core/form/constants/FormValidationEvent';
import { FormComputedValueMixin } from '/@/modules/core/form/mixins/FormComputedValueMixin';

export const FormValidationMixin = {
  mixins: [FormComputedValueMixin],
  props: {
    rules: { type: [String, Object] }
  },
  events() {
    return {
      [FormValidationEvent.SHOW_REQUIRED_FIELDS]: this.showRequiredFields,
      [FormValidationEvent.HIDE_REQUIRED_FIELDS]: this.hideRequiredFields
    };
  },
  data() {
    return {
      forceShowError: false
    };
  },
  methods: {
    async showRequiredFields() {
      if (!this.$refs.validationProvider?.rules?.required) {
        return;
      }
      await this.$refs.validationProvider?.validate();
      if (!this.$refs.validationProvider?.flags.invalid) {
        return;
      }

      this.forceShowError = true;
    },
    getErrorLabel() {
      let label = this.$t('core.info-is-missing');
      if (this.placeholder) {
        label = `${this.placeholder} is missing`;
      }
      if (this.labelText) {
        label = `${this.labelText} is missing`;
      }
      return label;
    },
    getErrorFormattedText(propsOrValidationProps) {
      const props = propsOrValidationProps.validationProps || propsOrValidationProps;

      if (!props || !props.errors) {
        return false;
      }
      if (this.forceShowError) {
        return this.getErrorLabel();
      }

      return props.errors.join(', ');
    },
    hideRequiredFields() {
      if (!this.$refs.validationProvider?.rules?.required) {
        return;
      }
      this.reset();
    },
    reset() {
      this.forceShowError = false;
      this.$refs.validationProvider?.reset();
    },
    getClasses({ errors = [] }) {
      return [];
    },
    hasValidationErrors(propsOrValidationProps) {
      if (!propsOrValidationProps) {
        return false;
      }

      // Handle when passed { validationProps: {...} }
      const props = propsOrValidationProps.validationProps || propsOrValidationProps;

      if (!props || !props.errors) {
        return false;
      }
      return !!props.errors.length && (this.forceShowError || !props.untouched);
    },
    hasMultiSelectValidationErrors(propsOrValidationProps) {
      if (!propsOrValidationProps) {
        return false;
      }

      // Handle when passed { validationProps: {...} }
      const props = propsOrValidationProps.validationProps || propsOrValidationProps;

      if (!props) {
        return false;
      }
      const errors = props.errors || [];
      const dirty = props.dirty;
      return !!errors.length && (this.forceShowError || dirty);
    }
  }
};
